module.exports = __webpack_public_path__ + "img/nata-blue.cb52f0e0.png";